import * as constants from './constants';
import { fromJS } from 'immutable';

const defaultState = fromJS({
	status: fromJS({})
});

const stateAction = (state = defaultState, action) => {
	switch(action.type) {
		case constants.CHANGE_STATUS:
			return state.merge({status: fromJS(action.status)});
		default:
			return state;
	}
}

export default stateAction;